/**
 * @module support/vesta
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/* tslint:disable:no-any */ // External js library so not sure about type
import { Injectable } from '@angular/core';
declare var Vesta;
import { AppConfig } from '@root/app.config';
import { Subject, Observable } from 'rxjs';
import { VestaToken } from '@support/vesta/interfaces/vesta.interface';

@Injectable()
export class VestaService {
  private vestaToken: Subject<VestaToken>;

  constructor(private appConfig: AppConfig) {}

  /**
   * initialize vesta services
   */
  public init(): void {
    const requestParams = {
      ServiceURL: this.appConfig.getConfig('vestaServiceURL'),
      AccountName: this.appConfig.getConfig('vestaAccountName'),
    };
    Vesta.init(requestParams);
  }

  /**
   * Method is used to get Credit Card token
   * @param {string} chargeAccountNumber
   * @returns {Observable<VestaToken>}
   */
  public getCreditCardToken(chargeAccountNumber: string): Observable<VestaToken> {
    this.vestaToken = new Subject();
    const radix = 10;
    const requestParams = {
      ChargeAccountNumber: parseInt(chargeAccountNumber, radix),
      onSuccess: this.onSuccess.bind(this),
      onFailed: this.onFailed.bind(this),
      onInvalidInput: this.onInvalidInput.bind(this),
    };
    Vesta.getcreditcardtoken(requestParams);
    return this.vestaToken;
  }

  /**
   * On Success return Subject of token
   * @param {object} data
   */
  private onSuccess(data: VestaToken): void {
    this.vestaToken.next(data);
    this.vestaToken.complete();
  }

  /**
   * On Failed return Subject of error
   * @param {VestaToken} error
   */
  private onFailed(error: VestaToken): void {
    this.vestaToken.next(error);
    this.vestaToken.complete();
  }

  /**
   * On Invalid Input return Subject of invalid response
   * @param {VestaToken} response
   */
  private onInvalidInput(response: VestaToken): void {
    this.vestaToken.next(response);
    this.vestaToken.complete();
  }
}
